import api from "@/assets/js/utils/api.js";
import {
  showSuccess,
  showError,
  showLoading,
  hideLoading,
} from "@/assets/js/utils/alertService.js";

export default {
  name: "ForgotPasswordView",
  data() {
    return {
      form: {
        email: "",
        captcha: "",
      },
      errors: {
        email: "",
        captcha: "",
      },
      captchaCode: "",
      isSubmitting: false,
      resetLinkSent: false,
    };
  },
  mounted() {
    this.generateCaptcha();
  },
  methods: {
    generateCaptcha() {
      this.captchaCode = Math.floor(1000 + Math.random() * 9000).toString();
    },
    refreshCaptcha() {
      this.generateCaptcha();
      this.form.captcha = "";
    },
    validateForm() {
      this.errors = { email: "", captcha: "" };
      let isValid = true;

      // ✅ 驗證 email
      if (!this.form.email) {
        this.errors.email = "請輸入電子郵件";
        isValid = false;
      }

      // ✅ 驗證 captcha
      if (!this.form.captcha) {
        this.errors.captcha = "請輸入驗證碼";
        isValid = false;
      } else if (this.form.captcha !== this.captchaCode) {
        this.errors.captcha = "驗證碼錯誤";
        this.refreshCaptcha();
        isValid = false;
      }

      return isValid;
    },

    async handleForgotPassword() {
      if (!this.validateForm()) return;

      try {
        showLoading("寄送中，請稍候..."); // ✅ Loading
        const response = await api.post("/front/customer/send-reset-password", {
          email: this.form.email,
        });

        hideLoading();

        // ✅ 成功
        if (response.data.success) {
          showSuccess(response.data.message || "重設密碼連結已寄送！");
        } else {
          showError(response.data.message || "寄送失敗");
        }
      } catch (error) {
        hideLoading();
        showError(error.response?.data?.message || "伺服器錯誤，請稍後再試");
      }
    },
  },
};
